import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MuiInputLabel from '@material-ui/core/InputLabel';
import Input from '@material-ui/core/Input';
import { mainColor } from '../../constants';

const styles = {
  root: {
    '&$focused': {
      color: '#009973'
    }
  },
  focused: {},
  input: {
    '&:after': {
      borderBottom: `2px solid #009973`
    }
  }
};
const InputLabel = withStyles({
  root: {
    '&.Mui-focused': {
      color: mainColor.secondaryColor
    }
  }
})(MuiInputLabel);

function SelectComponent (props) {
  const { classes, unit, children, label, id, name, onChange, margin, defaultValue, className, multiple, displayEmpty, disabled, required } = props;
  return (
    <FormControl
      margin={margin}
      className={className}
      required={required}
      InputProps={{
        classes: {
          underline: classes.input
        }
      }}
      FormLabelProps={{
        classes: {
          root: classes.label,
          focused: classes.focused
        }
      }}
    >
      <InputLabel shrink required={required}>{label}</InputLabel>
      <Select
        native={!multiple}
        multiple={multiple}
        displayEmpty={displayEmpty}
        defaultValue={defaultValue}
        value={unit}
        disabled={disabled}
        input={
          <Input
            classes={{
              underline: classes.input
            }}
            name={name}
            id={id}
          />
        }
        onChange={onChange}
        name={name}
        id={id}
        {...props}
      >
        {children}
      </Select>
    </FormControl>
  );
  
}

export default withStyles(styles)(SelectComponent);
